import React, { useContext } from 'react';
import classnames from 'classnames';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Details from '../../DeviationViews/Details';
import TextualContent from '../../DeviationViews/TextualContent';
import StageBackground from '../../DeviationBackground/StageBackground';
import { useDeviationViewContext } from '../../Context/DeviationViewContext';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { ScreenSizeContext } from '../../Measured';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import DesktopLayout from '../_partials/DesktopLayout';
import PanelPopup from '../_partials/PanelPopup';
import MonetizationStrip from '../../MonetizationStrip';
import s from './DesktopTextualPage.scss';
var DesktopTextualPage = function (_a) {
    var _b, _c, _d;
    var deviation = _a.deviation;
    var isTheater = useDeviationViewContext().isTheater;
    var isLegacyJournal = getDeviationType(deviation) === DeviationTypes.JOURNAL &&
        ((_b = deviation.textContent) === null || _b === void 0 ? void 0 : _b.html.type) === 'writer';
    var isLegacyView = isLegacyJournal && !((_c = deviation.extended) === null || _c === void 0 ? void 0 : _c.journalSkinFullwidth);
    var isFullWidthView = isLegacyJournal && ((_d = deviation.extended) === null || _d === void 0 ? void 0 : _d.journalSkinFullwidth);
    var contentClassName = classnames(s['content'], isLegacyView && s['is-legacy-journal'], isFullWidthView && s['is-fullwidth-skin']);
    var screenSize = useContext(ScreenSizeContext).width;
    return (React.createElement(DesktopLayout, { className: classnames(isTheater && s['theater']), deviation: deviation, stageContent: React.createElement(React.Fragment, null,
            React.createElement(ArtStage, { deviation: deviation }),
            React.createElement("div", { className: s['strip-tier-promotion-wrapper'] },
                React.createElement(MonetizationStrip, { className: s['strip-tier-promotion'], deviation: deviation })),
            React.createElement("div", { className: contentClassName },
                React.createElement(ActionBar, { deviation: deviation })),
            React.createElement(PanelPopup, { deviation: deviation, className: s['large-popover'], actionBarType: "primary" }),
            React.createElement("div", { className: contentClassName },
                React.createElement(TextualContent, { deviation: deviation }))), metaContent: React.createElement(React.Fragment, null,
            React.createElement(Details, { className: contentClassName, deviation: deviation }),
            React.createElement(UserGiftSaleBanner, { user: deviation.author })), backgroundContent: React.createElement(StageBackground, { deviation: deviation, width: Math.max(screenSize, 780) }), withSecondaryActionBar: true }));
};
DesktopTextualPage.displayName = 'DesktopTextualPage';
export default DesktopTextualPage;
//# sourceMappingURL=DesktopTextualPage.js.map